import React, {ReactNode} from 'react';
import Icon from '../icons/Icon';
import {initialPagePath, PagePath} from '../redux/reducers/PageReducer';
import ComponentName from '../constant/ComponentName';
import LanguageUtil from './LanguageUtil';
import PageUtil from './PageUtil';
import {CustomListTabType} from '../domain/custom-list/CustomListDomains';

class CustomListRouteUtil {

  public static resolveTab(value: string | null | undefined): CustomListTabType {
    switch (value) {
      case 'entity':
        return 'entity';
      case 'individual':
      default:
        return 'individual';
    }
  }

  public static parsePositiveInt(value: string | null, fallback: number): number {
    const parsed: number = Number(value ?? fallback);
    if (!Number.isFinite(parsed) || parsed < 1) {
      return fallback;
    }
    return Math.floor(parsed);
  }

  public static buildListBreadcrumb(listId: string, tab: CustomListTabType, listName?: string): PagePath[] {
    const pages: PagePath[] = [this.buildRootBreadcrumb()];
    if (listName) {
      pages.push(this.buildListCrumb(listId, tab, listName));
    }
    return pages;
  }

  public static buildRecordBreadcrumb(
    listId: string,
    tab: CustomListTabType,
    listName: string,
    recordName: string,
    recordPath: string,
  ): PagePath[] {
    return [
      this.buildRootBreadcrumb(),
      this.buildListCrumb(listId, tab, listName),
      {
        title: recordName,
        path: recordPath,
        icon: this.icon(),
        type: 'componentId',
        categoryId: 'Record',
        categoryPath: 'Main.List.Record',
        payload: {
          id: 'Record',
          name: 'Record',
          path: ['Main', 'List', 'Record'],
          components: [],
          categories: [],
          collaborators: [],
        },
      },
    ];
  }

  private static buildRootBreadcrumb(): PagePath {
    const initial = initialPagePath[ComponentName.CUSTOM_LIST];
    return {
      title: initial?.title ?? LanguageUtil.get({id: 'common.label.customList', defaultMessage: 'Custom List'}),
      path: '/custom-list',
      icon: this.icon(),
      type: 'category',
      categoryId: 'Main',
      categoryPath: 'Main',
      payload: PageUtil.calculateDefaultCategory(),
    };
  }

  private static buildListCrumb(listId: string, tab: CustomListTabType, listName: string): PagePath {
    return {
      title: listName,
      path: `/custom-list/${listId}/${tab}`,
      icon: this.icon(),
      type: 'componentId',
      categoryId: 'List',
      categoryPath: 'Main.List',
      payload: {
        id: 'List',
        name: 'List',
        path: ['Main', 'List'],
        components: [],
        categories: [],
        collaborators: [],
      },
    };
  }

  private static icon(): ReactNode {
    return <Icon icon={'customlisticon'} className={'text-f-black-2'} size={16}/>;
  }
}

export default CustomListRouteUtil;
